/// <reference path="../HTML/Container/Container.ts" />

namespace HA.Core.Entity {
    import AppContainer = HA.Core.HTML.Container;

    export class AppManager extends Entity {

        /**
         * @param nav {HANavigationApp}
         */
        public reloadNav(nav: HANavigationApp) {
            const qMenu = nav.getQMenu();
            if (qMenu && qMenu.size > 0) {
                this.setSubscribersData("qmenu", qMenu);
                this.notifySubscribers("qmenu");
            }
        }

        /**
         *
         * @param app
         */
        public update(app: App) {
           if (this.getApp()) {
                this.getApp().outro();
            }
            this.addToData("app", app);
            this.getAppContainer().replaceByTag(app.getTag());
            const appInfo = app.getInfo();
            if (appInfo) {
                this.setSubscribersData("appInfo", appInfo);
                this.notifySubscribers("appInfo");
            }
            const qMenu = app.getQMenu();

            if (qMenu && qMenu.size > 0) {
                this.setSubscribersData("qmenu", qMenu);
                this.notifySubscribers("qmenu");
            }
            app.intro();
        }

        protected getApp(): App {
            return this.get("app");
        }

        protected setApp(app: App) {
            this.addToData("app", app);
        }

        public subscribe(type: string, func: (d: any) => void) {
            const s: Map<any, any> = this.getSubscribers(type);
            if (s) {
                s.set(s.size, func);
                func(this.getSubscribersData(type));
            }
        }

        /**
         *
         * @param type
         * @returns {Map}
         */
        protected getSubscribers(type: string) {
            const subs: Map<string, any> = this.get("subscribers");

            return subs.get(type);
        }

        /**
         *
         * @param type
         * @param data
         */
        protected setSubscribersData(type: string, data: any) {
            const subsData: Map<string, any> = this.get("subscribersData");

            subsData.set(type, data);
        }

        /**
         *
         * @param type
         * @returns {Map}
         */
        protected getSubscribersData(type: string) {
            const subsData: Map<string, any> = this.get("subscribersData");
            return subsData.get(type);
        }

        /**
         *
         * @param type
         */
        protected notifySubscribers(type: string) {
            const s: Map<any, any> = this.getSubscribers(type);
            const me = this;
            if (s) {
                s.forEach((func) => {
                    func(me.getSubscribersData(type));
                });
            }
        }

        /**
         *
         * @returns {AppContainer}
         */
        protected getAppContainer() {
            return this.get("appContainer");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            const appCont = new AppContainer(data);
            this.addToData("appContainer", appCont);
            this.initSubscribers();
        }

        protected initSubscribers() {
            const s = new Map();
            const sd = new Map();
            s.set("appInfo", new Map());
            sd.set("appInfo", new Map());
            s.set("qmenu", new Map());
            sd.set("qmenu", new Map());
            this.addToData("subscribers", s);
            this.addToData("subscribersData", sd);
        }
    }
}
